import { render, staticRenderFns } from "./loadingRouting.vue?vue&type=template&id=28a98150&scoped=true&"
import script from "./loadingRouting.vue?vue&type=script&lang=js&"
export * from "./loadingRouting.vue?vue&type=script&lang=js&"
import style0 from "./loadingRouting.vue?vue&type=style&index=0&id=28a98150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a98150",
  null
  
)

export default component.exports